import { substituirHistoricoERecarregar } from '@/utils/navigation';

export default function redirecionarUsuario(callbackUrl: string | null): void {
  if (!callbackUrl) return substituirHistoricoERecarregar('/');
  const url = new URL(decodeURIComponent(callbackUrl));
  if (callbackUrl.includes('api')) {
    window.location.assign(url.toString());
    return;
  }
  substituirHistoricoERecarregar(url.pathname);
}
